"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeHelper = void 0;
const GameSetting_1 = require("../setting/GameSetting");
const MathHelper_1 = require("./MathHelper");
const UserAgent_1 = require("../useragent/UserAgent");
const EventHandler_1 = require("../event/EventHandler");
const StageEvent_1 = require("../stage/event/StageEvent");
class ResizeHelper {
    constructor() {
        if (ResizeHelper._instance)
            throw new Error(`Error: ResizeHelper.constructor(): Singelton problem!`);
        ResizeHelper._instance = this;
        ResizeHelper.addEventListeners();
    }
    static get resizeData() { return this._resizeData; }
    static get instance() { return this._instance; }
    static addEventListeners() {
        EventHandler_1.EventHandler.addFirstEventListener(this, StageEvent_1.StageEvent.STAGE_RESIZED, (event) => this.onStageResized(event.params[0]));
    }
    static onStageResized(resizeData) { this._resizeData = resizeData; }
    static calcDim(dim) {
        let oriDim = this.IsLandscape() ? dim.dimOrientation.landscape : dim.dimOrientation.portrait;
        let pos = new PIXI.Point(0, 0);
        let offPos = new PIXI.Point(0, 0);
        if (UserAgent_1.UserAgent.isMobile && this.IsLandscape()) {
            let leftRightOff = GameSetting_1.GameSetting.isLeftHanded ? oriDim.layout.left : oriDim.layout.right;
            offPos = MathHelper_1.MathHelper.pointSub(leftRightOff, oriDim.position);
            pos = GameSetting_1.GameSetting.isLeftHanded ? oriDim.layout.left : oriDim.layout.right;
        }
        else {
            pos = oriDim.position;
        }
        return {
            rotation: oriDim.rotation != undefined ? oriDim.rotation : 0,
            scale: oriDim.scale,
            offsetPosition: offPos,
            position: pos
        };
    }
    static IsLandscape() {
        return !this._resizeData || this._resizeData.orientation == "landscape";
    }
    static IsMobile() {
        return UserAgent_1.UserAgent.isMobile;
    }
    static isIPadd() {
        if (this.IsLandscape())
            return (ResizeHelper.resizeData.width >= 955 && ResizeHelper.resizeData.width <= 965);
        else
            return (ResizeHelper.resizeData.height >= 955 && ResizeHelper.resizeData.height <= 965);
    }
}
exports.ResizeHelper = ResizeHelper;
//# sourceMappingURL=ResizeHelper.js.map